import {Component, Input, OnInit} from '@angular/core';
import {ListItem} from "../../../objects/listItem";
import {DialogCanvasComponent} from "../../dialog-canvas/dialog-canvas.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {environment} from "../../../../environments/environment";
import {FS3Notification} from "../../../objects/notification";
import {AppEvent} from "../../../objects/appEvent";
import {AppComponent} from "../../../app.component";
import {SharedDataService} from "../../../services/shared-data.service";

@Component({
  selector: 'app-relation-button',
  templateUrl: './relation-button.component.html',
  styleUrls: []
})
export class RelationButtonComponent implements OnInit {
  @Input() listItem: ListItem
  state: string = 'default';
  constructor(public application: AppComponent,
              public sharedDataService: SharedDataService,
              public dialog: MatDialog) { }

  ngOnInit(): void {
  }

  relationClick(event,action_type): void {
    event.stopImmediatePropagation();
    //console.log('relationClick',action_type)
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      height: 'auto',
      data: {
        application: this,
        state: 'relation-confirmation',
        payload: {
          action_type: action_type,
          item: this.listItem,
        }
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((confirmed) => {
        if(confirmed) {
          this.state = 'loading';
          const pid = this.listItem['itemFullData']['id'];
          const cid = this.listItem['itemFullData']['relation_params']['__class'] ? this.listItem['itemFullData']['relation_params']['__class']['id'] : 0;
          this.application.apiService
            .relationConfirmation(environment['gid'],environment['g_hash'],pid,cid,action_type)
            .subscribe(
              data => {
                switch (action_type) {
                  case 'approve_as_friends':
                    this.listItem['itemFullData']['relation_params']['action'] = 'none';
                    this.listItem['itemFullData']['relation_params']['status'] = 'active';
                    break;
                  case 'remove_from_friends':
                    this.listItem['itemFullData']['relation_params']['action'] = 'none';
                    this.listItem['itemFullData']['relation_params']['status'] = 'removed';
                    break;
                  case 'approve_in_class':
                    this.listItem['itemFullData']['relation_params']['action'] = 'none';
                    this.listItem['itemFullData']['relation_params']['status'] = 'active';
                    break;
                  case 'remove_from_class':
                    this.listItem['itemFullData']['relation_params']['action'] = 'none';
                    this.listItem['itemFullData']['relation_params']['status'] = 'removed';
                    break;
                }
                this.state = 'default';
                let notification = new FS3Notification();
                notification.type = 'success';
                notification.text = 'Updated!';
                this.sharedDataService.pushNotification(notification);
                // let appEvent = new AppEvent(AppEvent.COMMUNITY_CLASS_DELETED,{"listItem": this.listItem});
                // this.sharedDataService.pushAppEvent(appEvent)
              },
              error => {
                this.state = 'error';
                const { exception } = error;
                if (exception && exception.error && exception.error.message) {
                  let notification = new FS3Notification();
                  notification.type = 'error';
                  notification.text = exception.error.message;
                  this.sharedDataService.pushNotification(notification);
                }
              }
            )
        }
      })
  }

}
